// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RoomNameInfo_wrapper__lbRz0","trigger":"RoomNameInfo_trigger__WLyqj","tooltip":"RoomNameInfo_tooltip__NPgMC"};